import React from 'react';
import { Paper, Typography, Box } from '@mui/material';

const placeholders = [
  {
    name: 'resubmission-message',
    desc: "Use this ID in the <p> tag for text detailing resubmission instructions. Paragraph will be included or removed based on rejection criteria."
  },
  {
    name: '{{BusinessUnit_name}}',
    desc: "The name of the company's business unit or department to whom invoice was issued"
  },
  {
    name: '{{supplier_name}}',
    desc: "The official name of the supplier or vendor whose invoice is being referenced."
  },
  {
    name: '{{invoice_date}}',
    desc: "The date the supplier’s invoice was issued."
  },
  {
    name: '{{invoice_receive_date}}',
    desc: "The date the supplier’s invoice was received."
  },
  {
    name: '{{original_attachment_name}}',
    desc: "The file name of the original invoice document or attachment submitted by the supplier"
  },
  {
    name: '{{rejection_reasons_en}}',
    desc: "The detailed reasons for invoice rejection, provided in English."
  },
  {
    name: '{{sender_email}}',
    desc: "The email address of the individual or team sending the rejection notification."
  },
  {
    name: '{{BU_Logo}}',
    desc: "The official logo or branding image of the respective business unit or company."
  },
];

export default function TemplatePlaceholdersReference() {
  return (
    <Paper elevation={2} sx={{ borderRadius: 3, p: 3, maxWidth: 400, background: 'var(--background-off-white)', boxShadow: 'none'}}>
      <Typography variant="h6" fontWeight="bold" gutterBottom sx={{fontSize: '16px'}}>
        Template Content Identifiers
      </Typography>
      <Box>
        {placeholders.map((item, idx) => (
          <Box key={item.name} mb={2}>
            <Typography variant="body2" mb={.5} sx={{fontSize: '12px', lineHeight: '16px',}}>
              {item.name}
            </Typography>
            <Typography variant="body2" sx={{fontSize: '12px', lineHeight: '16px',}}>
              {item.desc}
            </Typography>
          </Box>
        ))}
      </Box>
    </Paper>
  );
}
